import { useCallback, useEffect, useState } from 'react';
import { fetchOrgRcmSettings } from '../dateRange/orgDefaultDateRange';

export const ORG_AI_CONTRIBUTION_UPDATED_EVENT = 'rcm-org-ai-contribution-updated';

export function notifyOrgAIContributionUpdated() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ORG_AI_CONTRIBUTION_UPDATED_EVENT));
  }
}

/**
 * Organization-wide preference for showing AI contribution in RCM analytics.
 * Source of truth: organizations.settings.rcm.show_ai_contribution.
 */
export function useOrgAIContribution() {
  const [showAIContribution, setShowAIContribution] = useState(true);
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const rcm = await fetchOrgRcmSettings();
      setShowAIContribution(rcm?.show_ai_contribution !== false);
    } catch {
      setShowAIContribution(true);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const onUpdate = () => load();
    window.addEventListener(ORG_AI_CONTRIBUTION_UPDATED_EVENT, onUpdate);
    const onMessage = (event) => {
      const rcm =
        event?.data?.organizationRcmSettings ||
        (event?.data?.type === 'ORGANIZATION_CONTEXT' && event.data.organizationRcmSettings);
      if (rcm && typeof rcm === 'object') {
        try {
          sessionStorage.setItem('organization_rcm_settings', JSON.stringify(rcm));
        } catch {
          /* ignore */
        }
        load();
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener(ORG_AI_CONTRIBUTION_UPDATED_EVENT, onUpdate);
      window.removeEventListener('message', onMessage);
    };
  }, [load]);

  return { showAIContribution, ready, reload: load };
}

export default useOrgAIContribution;
